// The latest statement email to one patient, as a chip: "Emailed", "Link opened",
// "Paid", "Bounced"…  Mounted on the Statements table and in the patient drawer,
// one line each:
//
//   <PayStatusChip practiceId={practiceId} patientId={patientId} />
//
// It gates itself: nothing renders without `features.collections`, without a send
// for this patient, or when the read fails (a client-role user has no collections
// page and gets a 403). Every chip on a page shares one request (api.js).

import React, { useEffect, useState } from "react";
import useCapabilities from "../../hooks/useCapabilities";
import { fetchPayStatus, formatWhen, sendStatusChip } from "./api";
import "./Collections.css";

export default function PayStatusChip({
  practiceId,
  patientId,
  variant = "inline",
}) {
  const { features } = useCapabilities(practiceId);
  const enabled = !!practiceId && patientId != null && !!features.collections;
  const [entry, setEntry] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setEntry(null);
    fetchPayStatus(practiceId)
      .then((patients) => {
        if (!cancelled) setEntry(patients[String(patientId)] || null);
      })
      .catch(() => {
        if (!cancelled) setEntry(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, practiceId, patientId]);

  if (!enabled || !entry || !entry.status) return null;
  const chip = sendStatusChip(entry.status);
  const when = formatWhen(entry.sent_at);
  const badge = (
    <span
      className={`coll-chip ${chip.tone} coll-pay-chip`}
      title={`Latest statement email: ${chip.label.toLowerCase()} (sent ${when})`}
    >
      {chip.label}
    </span>
  );
  // The drawer has no row to sit in, so it gets a labelled line of its own.
  if (variant === "drawer") {
    return (
      <div className="coll-pay-strip">
        <span>Latest statement email</span>
        {badge}
        <span className="coll-muted">sent {when}</span>
      </div>
    );
  }
  return badge;
}
